import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { ClientContract } from './clientContract';


@JsonObject('ContractSearchResults')
export class ContractSearchResults extends SearchResults {
    @JsonProperty('results', [ClientContract])
    results: ClientContract[] = [];
}
